import { useLingui } from '@lingui/react/macro';
import ErrorPage from './error-page.tsx';
import AppLayout from '../../app-layout.tsx';

/**
 * Rendert eine Fehlerseite, die angezeigt wird, wenn ein unerwarteter Fehler auftritt.
 * Die Seite zeigt eine Titel- und eine Fehlermeldung, die internationalisiert sind.
 */
export default function UnexpectedErrorPage() {
  const { t } = useLingui();

  return (
    <AppLayout>
      <ErrorPage title={t`Unerwarteter Fehler`} errorText={t`Ein unerwarteter Fehler ist aufgetreten!`} />
    </AppLayout>
  );
}
